module.exports = __webpack_public_path__ + "media/img/event/speakers/Asier-Baquero-5e32b5c6ca43ba5495aa85d420b530db.jpg";